module.exports = __webpack_public_path__ + "img/streaming_butterfly.48b4857d.svg";